<template>
  <div class="columns">
    <b-field
      class="column"
      :label="$translate('size') | capitalize"
      :message="errors.first('size')"
      :type="{ 'is-danger': errors.has('size') }"
    >
      <b-input
        v-validate="'required|decimal:*,.'"
        data-vv-validate-on="blur"
        v-model="size.size"
        name="size"
        type="text"
      />
    </b-field>
    <b-field
      class="column"
      :label="$translate('ball') | capitalize"
      :message="errors.first('ball')"
      :type="{ 'is-danger': errors.has('ball') }"
    >
      <b-input v-validate="'required|decimal:*,.'" data-vv-validate-on="blur" v-model="size.ball" name="ball" />
    </b-field>
    <b-field
      v-if="module === 'fits'"
      class="column"
      :label="$translate('instep') | capitalize"
      :message="errors.first('instep')"
      :type="{ 'is-danger': errors.has('instep') }"
    >
      <b-input v-validate="'required|decimal:*,.'" data-vv-validate-on="blur" v-model="size.instep" name="instep" />
    </b-field>
    <b-field
      v-show="module === 'fits' || module === 'modular'"
      class="column"
      :label="$translate('instep_italy') | capitalize"
      :message="errors.first('instep_italy')"
      :type="{ 'is-danger': errors.has('instep_italy') }"
    >
      <b-input
        v-validate="'required|decimal:*,.'"
        data-vv-validate-on="blur"
        v-model="size.instep_italy"
        name="instep_italy"
      />
    </b-field>
    <b-field
      class="column"
      :label="$translate('heel') | capitalize"
      :message="errors.first('heel')"
      :type="{ 'is-danger': errors.has('heel') }"
    >
      <b-input v-validate="'required|decimal:*,.'" data-vv-validate-on="blur" v-model="size.heel" name="heel" />
    </b-field>
    <b-field
      class="column"
      v-if="type === 'high' && module === 'fits'"
      :label="$translate('end_tomaia') | capitalize"
      :message="errors.first('end_tomaia')"
      :type="{ 'is-danger': errors.has('end_tomaia') }"
    >
      <b-input
        v-validate="'required|decimal:*,.'"
        data-vv-validate-on="blur"
        v-model="size.end_tomaia"
        name="end_tomaia"
      />
    </b-field>
    <b-field
      class="column"
      :label="$translate('length') | capitalize"
      :message="errors.first('length')"
      :type="{ 'is-danger': errors.has('length') }"
    >
      <b-input v-validate="'required|decimal:*,.'" data-vv-validate-on="blur" v-model="size.length" name="length" />
    </b-field>
    <b-field
      class="column"
      :label="$translate('width') | capitalize"
      :message="errors.first('width')"
      :type="{ 'is-danger': errors.has('width') }"
    >
      <b-input v-validate="'required|decimal:*,.'" data-vv-validate-on="blur" v-model="size.width" name="width" />
    </b-field>
    <b-field
      class="column"
      :label="$translate('toe_height') | capitalize"
      :message="errors.first('toe_height')"
      :type="{ 'is-danger': errors.has('toe_height') }"
    >
      <b-input
        v-validate="'required|decimal:*,.'"
        data-vv-validate-on="blur"
        v-model="size.toe_height"
        name="toe_height"
      />
    </b-field>
    <b-field class="column has-text-right delete-button" label="delete">
      <button class="button is-danger" @click="deleteRow(index)">
        <b-icon icon="delete-outline"></b-icon>
      </button>
    </b-field>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    module: {
      type: String,
      required: true,
    },
  },
  $_veeValidate: {
    validator: 'new',
  },
  methods: {
    deleteRow(index) {
      this.$emit('delete-row', index)
    },
    validateBeforeSubmit() {
      return this.$validator.validateAll()
    },
  },
}
</script>

<style scoped>
/deep/ .delete-button > .label {
  color: transparent;
}
/deep/ .field > .label {
  font-size: 0.75rem;
}
</style>
